"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedColorOptionResponse = void 0;
exports.mockedColorOptionResponse = {
  id: 1,
  name: {
    id: 1,
    en: 'en',
    ru: 'ru'
  },
  hexCode: '#FFF'
};